const RestaurantsIcon = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.1765 21V3.375H15.5588C16.4715 3.375 17.3468 3.73058 17.9921 4.36351C18.6374 4.99645 19 5.85489 19 6.75V13.875H18.6176C18.1106 13.875 17.6244 14.0725 17.2658 14.4242C16.9073 14.7758 16.7059 15.2527 16.7059 15.75M8.67647 21V10.125M8.67647 10.125C9.38631 10.125 10.0671 9.84844 10.569 9.35616C11.071 8.86387 11.3529 8.19619 11.3529 7.5V3M8.67647 10.125C7.96663 10.125 7.28586 9.84844 6.78392 9.35616C6.28198 8.86387 6 8.19619 6 7.5V3M8.67647 3V8.625"
      stroke="black" strokeWidth="0.5"/>
  </svg>
);

export default RestaurantsIcon;
